import { useEffect, useRef } from "react";
import gsap from "gsap";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const circleRef = useRef(null);
  const isTouch = typeof window !== "undefined" && !window.matchMedia("(pointer: fine)").matches;

  useEffect(() => {
    if (isTouch) return;

    const dot = dotRef.current;
    const circle = circleRef.current;

    const moveDot = gsap.quickTo(dot, "left", { duration: 0.15, ease: "power3.out" });
    const moveDotY = gsap.quickTo(dot, "top", { duration: 0.15, ease: "power3.out" });
    const moveCircle = gsap.quickTo(circle, "left", { duration: 0.4, ease: "power3.out" });
    const moveCircleY = gsap.quickTo(circle, "top", { duration: 0.4, ease: "power3.out" });

    const onMouseMove = (e) => {
      moveDot(e.clientX);
      moveDotY(e.clientY);
      moveCircle(e.clientX);
      moveCircleY(e.clientY);
    };

    const onMouseEnterInteractive = () => {
      gsap.to(circle, { scale: 1, opacity: 0.15, duration: 0.3, ease: "power3.out" });
      gsap.to(dot, { scale: 0.5, duration: 0.3, ease: "power3.out" });
    };

    const onMouseLeaveInteractive = () => {
      gsap.to(circle, { scale: 0.4, opacity: 0, duration: 0.3, ease: "power3.out" });
      gsap.to(dot, { scale: 1, duration: 0.3, ease: "power3.out" });
    };

    window.addEventListener("mousemove", onMouseMove);

    const addListeners = () => {
      const interactives = document.querySelectorAll("a, button, [data-cursor-hover]");
      interactives.forEach((el) => {
        el.addEventListener("mouseenter", onMouseEnterInteractive);
        el.addEventListener("mouseleave", onMouseLeaveInteractive);
      });
      return interactives;
    };

    let interactives = addListeners();

    const observer = new MutationObserver(() => {
      interactives.forEach((el) => {
        el.removeEventListener("mouseenter", onMouseEnterInteractive);
        el.removeEventListener("mouseleave", onMouseLeaveInteractive);
      });
      interactives = addListeners();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      observer.disconnect();
      interactives.forEach((el) => {
        el.removeEventListener("mouseenter", onMouseEnterInteractive);
        el.removeEventListener("mouseleave", onMouseLeaveInteractive);
      });
    };
  }, []);

  const shared = {
    position: "fixed",
    pointerEvents: "none",
    zIndex: 10000,
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    top: 0,
    left: 0,
  };

  if (isTouch) return null;

  return (
    <>
      <div
        ref={dotRef}
        style={{
          ...shared,
          width: 8,
          height: 8,
          backgroundColor: "#1A1A1A",
        }}
      />
      <div
        ref={circleRef}
        style={{
          ...shared,
          width: 60,
          height: 60,
          border: "1px solid #1A1A1A",
          opacity: 0,
          transform: "translate(-50%, -50%) scale(0.4)",
        }}
      />
    </>
  );
}
